/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFwLeaderboardsCharactersVictoryPoints } from './GetFwLeaderboardsCharactersVictoryPoints';
import {
    GetFwLeaderboardsCharactersVictoryPointsFromJSON,
    GetFwLeaderboardsCharactersVictoryPointsFromJSONTyped,
    GetFwLeaderboardsCharactersVictoryPointsToJSON,
    GetFwLeaderboardsCharactersVictoryPointsToJSONTyped,
} from './GetFwLeaderboardsCharactersVictoryPoints';
import type { GetFwLeaderboardsCharactersKills } from './GetFwLeaderboardsCharactersKills';
import {
    GetFwLeaderboardsCharactersKillsFromJSON,
    GetFwLeaderboardsCharactersKillsFromJSONTyped,
    GetFwLeaderboardsCharactersKillsToJSON,
    GetFwLeaderboardsCharactersKillsToJSONTyped,
} from './GetFwLeaderboardsCharactersKills';

/**
 * 200 ok object
 * @export
 * @interface GetFwLeaderboardsCharactersOk
 */
export interface GetFwLeaderboardsCharactersOk {
    /**
     * 
     * @type {GetFwLeaderboardsCharactersKills}
     * @memberof GetFwLeaderboardsCharactersOk
     */
    kills: GetFwLeaderboardsCharactersKills;
    /**
     * 
     * @type {GetFwLeaderboardsCharactersVictoryPoints}
     * @memberof GetFwLeaderboardsCharactersOk
     */
    victoryPoints: GetFwLeaderboardsCharactersVictoryPoints;
}

/**
 * Check if a given object implements the GetFwLeaderboardsCharactersOk interface.
 */
export function instanceOfGetFwLeaderboardsCharactersOk(value: object): value is GetFwLeaderboardsCharactersOk {
    if (!('kills' in value) || value['kills'] === undefined) return false;
    if (!('victoryPoints' in value) || value['victoryPoints'] === undefined) return false;
    return true;
}

export function GetFwLeaderboardsCharactersOkFromJSON(json: any): GetFwLeaderboardsCharactersOk {
    return GetFwLeaderboardsCharactersOkFromJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsCharactersOk {
    if (json == null) {
        return json;
    }
    return {
        
        'kills': GetFwLeaderboardsCharactersKillsFromJSON(json['kills']),
        'victoryPoints': GetFwLeaderboardsCharactersVictoryPointsFromJSON(json['victory_points']),
    };
}

export function GetFwLeaderboardsCharactersOkToJSON(json: any): GetFwLeaderboardsCharactersOk {
    return GetFwLeaderboardsCharactersOkToJSONTyped(json, false);
}

export function GetFwLeaderboardsCharactersOkToJSONTyped(value?: GetFwLeaderboardsCharactersOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kills': GetFwLeaderboardsCharactersKillsToJSON(value['kills']),
        'victory_points': GetFwLeaderboardsCharactersVictoryPointsToJSON(value['victoryPoints']),
    };
}

